module.exports = __webpack_public_path__ + "media/images/app/occasions/birthday-25df6c318a6a6459faf6557e89c783a7.webp";